/**
 * Device detection utility functions
 */

/**
 * Detect if the user is on an iOS device
 * @returns {boolean} true if iOS device, false otherwise
 */
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

/**
 * Detect if the user is on an Android device
 * @returns {boolean} true if Android device, false otherwise
 */
export function isAndroid() {
  return /Android/.test(navigator.userAgent)
}

/**
 * Get the appropriate app store link based on device
 * @returns {object} object with store URL and platform info
 */
export function getAppStoreInfo() {
  if (isIOS()) {
    return {
      platform: 'ios',
      url: 'https://apps.apple.com/us/app/formbeat/id1539444595',
      icon: require('images/icons/download-app-store.svg'),
      alt: 'Cycling training app for iOS'
    }
  } else if (isAndroid()) {
    return {
      platform: 'android',
      url: 'https://play.google.com/store/apps/details?id=com.formbeat.www',
      icon: require('images/icons/download-google-play.svg'),
      alt: 'Cycling training app for Android'
    }
  } else {
    // Default to iOS for desktop/unknown devices
    return {
      platform: 'ios',
      url: 'https://apps.apple.com/us/app/formbeat/id1539444595',
      icon: require('images/icons/download-app-store.svg'),
      alt: 'Cycling training app for iOS'
    }
  }
}
